module.exports = __webpack_public_path__ + "img/exportSave.0fe748db.svg";